/*---------------------------------------------------------
 The following JavaScript functions control Booking Basket
-----------------------------------------------------------*/

var TECL_BookingBasket = {

  // Whether to display the booking basket on page open
  DisplayBookingBasket: function () {
    CallServer({
      key: "TECL_BookingBasket.DisplayBookingBasket",
      controller: "BookingsSurface",
      action: "DisplayBookingBasket",
      success: function (partialViewHtml) {
        if (partialViewHtml && partialViewHtml.length > 0) {
          TECL_BottomNavPopOut.DisplayList(partialViewHtml, false);
        }
      }
    });
  },

  // Add an booking entry
  AddBooking: function (productId, productGuidId, productName) {
    if (productId || productGuidId) {
      CallServer({
        key: "TECL_BookingBasket.AddBooking",
        controller: "BookingsSurface",
        action: "AddBookingItem",
        data: {
          productId: productId,
          productGuidId: productGuidId
        },
        success: function (partialViewHtml) {

          //Add product selection to google analytics
          if (window.hasOwnProperty("ga") && productName && productName.length > 0) {
            var trackerName = window.ga.getAll()[0].get("name");
            window.ga(trackerName + ".send", "event", "cta", "click", "enquire", "product-booking", { "dimension1": "product", "dimension2": productName });
          }

          TECL_BottomNavPopOut.DisplayList(partialViewHtml, true);
        }
      });
    }
  },

  // Delete an booking item
  DeleteOrderLineItem: function (orderLineItemId) {
    if (orderLineItemId) {
      CallServer({
        key: "TECL_BookingBasket.DeleteOrderLineItem",
        controller: "BookingsSurface",
        action: "DeleteBookingItem",
        data: {
          orderLineItemId: orderLineItemId
        },
        success: function (partialViewHtml) {
          TECL_BottomNavPopOut.DisplayList(partialViewHtml, true);
        }
      });
    }
  },

  // Display the user registration controls
  SubmitBookings: function () {
    var userDetails = TECL_BookingBasket.ValidateUserDetails();
    if (userDetails) {
      CallServer({
        key: "TECL_BookingBasket.SubmitBookings",
        controller: "BookingsSurface",
        action: "SubmitBookings",
        data: {
          userDetails: userDetails
        },
        success: function (result) {
          if (result && result.Saved) {

            //show send feedback
            TECL_BottomNavPopOut.Hide();

            //Add booking basket submmission to google analytics
            if (window.hasOwnProperty("ga") && result.ProductNames && result.ProductNames.length > 0) {
              var trackerName = window.ga.getAll()[0].get("name");
              window.ga(trackerName + ".send", "event", "form", "success", "product-booking", { "dimension1": "product", "dimension2": result.ProductNames });
            }

            ShowQuickDisplayDialog("Booking Sent", 2500);
          } else {
            // show send failure error
            $("#bookingBasketUserSubmitErr").removeClass("hidden");
          }
        }
      });
    }
  },
  
  // Move back to the booking basket
  BackToBookingBasket: function() {
    TECL_BookingBasket.ChangeBookingBasketDisplay(false);
  },

  // Clear validation error fields
  ClearErrorFields: function () {
    $("#bookingBasketUserNameErr").addClass("hidden");
    $("#bookingBasketUserEmailErr").addClass("hidden");
    $("#bookingBasketUserInvEmailErr").addClass("hidden");
    $("#bookingBasketUserMessageErr").addClass("hidden");
    $("#bookingBasketUserSubmitErr").addClass("hidden");
  },

  // Validate and get all the user detail information
  ValidateUserDetails: function () {
    TECL_BookingBasket.ClearErrorFields();

    var webAccountId = $("#bookingBasketUserWebAccountId").val();
    var name = $("#bookingBasketUserName").val();
    var organisationName = $("#bookingBasketUserOrganisation").val();
    var emailAddress = $("#bookingBasketUserEmail").val();
    var phoneNumber = $("#bookingBasketUserPhoneNumber").val();
    var message = $("#bookingBasketUserMessage").val();
    var noErrors = true;

    if (!name || name.length <= 0) {
      $("#bookingBasketUserNameErr").removeClass("hidden");
      noErrors = false;
    }

    if (!emailAddress || emailAddress.length <= 0) {
      $("#bookingBasketUserEmailErr").removeClass("hidden");
      noErrors = false;
    } else if (!TECL_Validation.ValidateEmailAddress(emailAddress)) {
      $("#bookingBasketUserInvEmailErr").removeClass("hidden");
      noErrors = false;
    }

    if (!message || message.length <= 0) {
      $("#bookingBasketUserMessageErr").removeClass("hidden");
      noErrors = false;
    }

    var userDetails;

    if (noErrors) {
      userDetails =
      {
        WebAccountId: webAccountId,
        Name: name,
        OrganisationName: organisationName,
        EmailAddress: emailAddress,
        PhoneNumber: phoneNumber,
        Message: message
      }
    } else {
      userDetails = null;
    }
    return userDetails;
  },
  
  // Display the Booking basket or user details
  ChangeBookingBasketDisplay: function(changeToUserDetails) {
    TECL_BookingBasket.ClearErrorFields();

    if (changeToUserDetails) {
      $("#bookingBasketItems").addClass("hidden");
      $("#bookingBasketUserDetails").removeClass("hidden");
    } else {
      $("#bookingBasketItems").removeClass("hidden");
      $("#bookingBasketUserDetails").addClass("hidden");
    }
    TECL_BottomNavPopOut.OpenNav();
  }

}
